import {
    AccessIcon, AdditionalSettingsIcon, AmenitySettingsIcon, ApprovalsIcon, BankIcon, ChangePasswordIcon, CommunityPolicyIcon, CommunitySettingsIcon, CommunitySetupIcon, ComplaintsIcon, DashboardIcon, ExpenseIcon, FinanceIcon, GenerateBillIcon, MyPaymentsIcon, PaymentCollectionIcon, PaymentHistoryIcon, PaymentIcon, PrivacyPolicyIcon, ReceptionDeskIcon, SettingsIcon, SubscriptionsIcon, TermsAndConditionIcon, UsersGroup, UsersIcon, UsersRolesIcon,
    AnnouncementsIcon, VisitorLogIcon, AccessTickIcon, BankApprovalIcon, VisitorApprovalIcon, JoinApprovalIcon, LogoutIcon,
    DeleteAccount,
    ReportIcon,
    WalletMenuIcon
} from "../assets/constant";

export const decideMenuIcon = (type) => {
    switch (type) {
        case 'custom-dashboard':
            return <DashboardIcon />;
        case 'custom-community-setup':
            return <CommunitySetupIcon />;
        case 'custom-amenity-settings':
            return <AmenitySettingsIcon />;
        case 'custom-community-settings':
            return <CommunitySettingsIcon />;
        case 'custom-additional-settings':
            return <AdditionalSettingsIcon />;
        case 'custom-announcements':
            return <AnnouncementsIcon />;
        case 'custom-community-policy':
            return <CommunityPolicyIcon />;
        // Payment & Bills
        case 'custom-finance':
            return <FinanceIcon />;
        case 'custom-bank':
            return <BankIcon />;
        case 'custom-expense':
            return <ExpenseIcon />;
        // Payment & Bills
        case 'custom-payments':
            return <PaymentIcon />;
        case 'custom-generate-bill':
            return <GenerateBillIcon />;
        case 'custom-payment-collection':
            return <PaymentCollectionIcon />;
        case 'custom-payment-history':
            return <PaymentHistoryIcon />;
        case 'custom-my-payments':
            return <MyPaymentsIcon />;
            {/* ==== Complaints ==== */ }
        case 'custom-complaints':
            return <ComplaintsIcon />;
            {/* ==== Access ==== */ }
        case 'custom-access':
            return <AccessIcon />;
        case 'custom-visitors-log':
            return <VisitorLogIcon />;
        case 'custom-reception-desk':
            return <ReceptionDeskIcon />;
        case 'custom-approvals':
            return <AccessTickIcon />;
            {/* ==== Users & Roles ==== */ }
        case 'custom-users-roles':
            return <UsersRolesIcon />;
        case 'custom-users':
            return <UsersIcon />;
        case 'custom-user-group':
            return <UsersGroup />;
        case 'custom-settings':
            return <SettingsIcon />;
        case 'custom-subscriptions':
            return <SubscriptionsIcon />;
        case 'custom-change-password':
            return <ChangePasswordIcon />;
        case 'custom-terms-and-conditions':
            return <TermsAndConditionIcon />;
        case 'custom-privacy-policy':
            return <PrivacyPolicyIcon />;
        case "custom-bank-approval":
            return <BankApprovalIcon />;
        case "custom-visitor-approval":
            return <VisitorApprovalIcon />;
        case "custom-join-approval":
            return <JoinApprovalIcon />;
        case "custom-delete-account":
            return <DeleteAccount />;
        case "custom-reports":
            return <ReportIcon />;
        case "custom-wallet":
            return <WalletMenuIcon />;
        default:
            return 'unknown';
    }
}